export enum SuspensionStateEnums {
  open = 1,
  closed = 2,
  annul = 3,
  printed = 4
}